import { format, parseISO } from "date-fns";

const customTextColor = "#3f475a";
const BgColor = "#f0f2f5";
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return format(date, "dd MMM yyyy");
};

const formatTime = (dateString) => {
  const date = new Date(dateString);
  return format(date, "h:mm a"); // 'h:mm a' formats time without seconds and with am/pm
};

const whichStatus = (value) => {
  let status;
  if (value === "INTERNAL_SUBMISSION") {
    status = "Submitted";
  } else if (value === "ECI_SUBMISSION") {
    status = "Eci Submission";
  } else if (value === "EC_SUBMISSION") {
    status = "Ec Submission";
  } else if (value === "1st_ROUND_OF_INTERVIEW") {
    status = "1st round intro";
  } else if (value === "2nd_ROUND_OF_INTERVIEW") {
    status = "2nd round intro";
  } else if (value === "3rd_ROUND_OF_INTERVIEW") {
    status = "3rd round intro";
  } else if (value === "OFFER_CONFIRMATION") {
    status = "offer confirmation";
  } else if (value === "REJECTED") {
    status = "Rejected";
  } else if (value === "DECLINED_BY_SALES_MANAGER") {
    status = "Declined";
  }
  return status;
};

const changeCandidateStatus = (value) => {
  let status;
  if (value === "PENDING_WITH_RECRUITER") {
    status = "Pending with Recruiter";
  } else if (value === "QUESTION_BY_CANDIDATE") {
    status = "Question by Candidate";
  } else if (value === "INTERESTED_BY_CANDIDATE") {
    status = "Interested by candidate";
  } else if (value === "1st_ROUND_OF_INTERVIEW") {
    status = "1st round intro";
  } else if (value === "2nd_ROUND_OF_INTERVIEW") {
    status = "2nd round intro";
  } else if (value === "3rd_ROUND_OF_INTERVIEW") {
    status = "3rd round intro";
  } else if (value === "4th_ROUND_OF_INTERVIEW") {
    status = "4th round intro";
  } else if (value === "REJECTED_BY_RECRUITER") {
    status = "Rejected";
  } else if (value === "SELECTED") {
    status = "Selected";
  }
  return status;
};

const whichFile = (value) => {
  let status;
  if (value === "pdf") {
    status = "application/pdf";
  } else if (value === "webp") {
    status = "image/webp";
  } else if (value === "json") {
    status = "application/json";
  } else if (value === "csv") {
    status = "text/csv";
  } else if (value === "txt") {
    status = "text/plain";
  } else if (value === "docx") {
    status =
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  } else if (value === "docm") {
    status = "application/vnd.ms-word.document.macroenabled.12";
  } else if (value === "dot") {
    status = "application/msword.template.macroenabled.8";
  } else if (value === "dotm") {
    status = "application/vnd.ms-word.template.macroenabled.12";
  } else if (value === "dotx") {
    status =
      "application/vnd.openxmlformats-officedocument.wordprocessingml.template";
  }
  return status;
};

function calculateFieldCompletion(data, prefer_tax_team) {
  const totalFields = Object.keys(data).length - 2;
  const skillCompletion =
    data.skills && data.skills.length >= 10
      ? 10
      : data.skills
      ? data.skills.length
      : 0;

  let filledFields = 0;
  for (let key in data) {
    if (key !== "skills" && data[key] !== null && data[key] !== "") {
      filledFields++;
    }
  }


  let otherFieldsCompletion;
  if (
    prefer_tax_team === "contract" ||
    prefer_tax_team === "contract_to_hire"
  ) {
    otherFieldsCompletion = Math.round((filledFields / totalFields) * 90);
  } else {
    let allTotalField = totalFields - 4;
    otherFieldsCompletion = Math.round((filledFields / allTotalField) * 90);
  }
  const filledPercentage = Math.min(
    100,
    skillCompletion + otherFieldsCompletion
  );
  const emptyPercentage = 100 - filledPercentage;

  return { filledPercentage, emptyPercentage };
}

const getCandidateStatus = (value) => {
  let status = "";
  if (value?.length > 0) {
    status = value?.[0]?.candidate_status;
  } else {
    status = "none";
  }
  return status;
};

const ShortenName = (name) => {
  const displayName = name?.length > 15 ? name?.slice(0, 15) + "..." : name;

  return displayName;
};

const ShortenName3 = (name) => {
  const displayName = name?.length > 15 ? name?.slice(0, 20) + "..." : name;

  return displayName;
};

const ShortenName2 = (name) => {
  const displayName = name?.length > 15 ? name?.slice(0, 30) + "..." : name;

  return displayName;
};

const splitIntoColumns = (skills, columns) => {
  const result = Array?.from({ length: columns }, () => []);
  skills?.forEach((skill, index) => {
    result[index % columns]?.push(skill);
  });
  return result;
};

// const convertArrayToString = (array) => {
//   return array?.join(", ");
// };

const convertArrayToString = (array) => {
  return array
    ?.map(
      (item) =>
        item
          .replace(/_/g, " ") // Replace underscores with spaces
          .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
    )
    .join(", ");
};

const convertArrayToStringWithCount = (array) => {

  const formatted = array
    ?.map(
      (item) =>
        item
          .replace(/_/g, " ") // Replace underscores with spaces
          .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
    )
    .filter(Boolean); // Remove any undefined/null items

  if (!formatted || formatted.length === 0) return "";

  const firstTwo = formatted.slice(0, 2);
  const remainingCount = formatted.length - 2;

  return remainingCount > 0
    ? `${firstTwo.join(", ")} +${remainingCount}`
    : firstTwo.join(", ");
};

// function formatArrayString(arrayString) {
//   try {
//     // Parse the string to a JSON array
//     const array = JSON.parse(arrayString);
//     // Join the array to form a comma-separated string
//     return array
//       ?.map(
//         (item) =>
//           item
//             .replace(/_/g, " ") // Replace underscores with spaces
//             .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
//       )
//       .join(", ");
//   } catch (error) {
//     console.error("Invalid JSON string:", error);
//     return "";
//   }
// }

function formatArrayString(value) {
  try {
    // If already an array
    if (Array.isArray(value)) {
      return value
        .map((item) =>
          item
            ?.replace(/_/g, " ")
            ?.replace(/\b\w/g, (char) => char.toUpperCase())
        )
        .join(", ");
    }

    // If null, undefined, or invalid string
    if (!value || value === "undefined") return "";

    // If it's a string, try to parse it
    const parsed = JSON.parse(value);

    if (!Array.isArray(parsed)) return "";

    return parsed
      .map((item) =>
        item
          ?.replace(/_/g, " ")
          ?.replace(/\b\w/g, (char) => char.toUpperCase())
      )
      .join(", ");
  } catch (error) {
    console.error("Invalid formatArrayString input:", error);
    return "";
  }
}


function formatShortDate(isoDateString) {
  const date = new Date(isoDateString);

  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" }); // e.g., Jan, Feb
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
}

const shortDateTime = (dateString) => {
  if (!dateString) return "";

  try {
    const parsedDate = parseISO(dateString);
    return format(parsedDate, "dd MMM yyyy, h:mm a"); // Date and time in 12-hour format with AM/PM
  } catch (error) {
    console.error("Error parsing date:", error);
    return "Invalid Date";
  }
};

function formatShortDateTime(isoDateString) {
  const date = new Date(isoDateString);

  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" }); // e.g., Jan, Feb
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const amPm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // Convert 24-hour format to 12-hour format

  return `${day} ${month} ${year}, ${hours}:${minutes} ${amPm}`;
}

// const combineDateTime = (dateStr, timeStr) => {
//   // Extract time from the given timestamp
//   const time = new Date(timeStr).toISOString().split("T")[1].split(".")[0]; // Extracts "22:30:00"

//   // Create new Date with the provided date and extracted time
//   const newDateTime = new Date(`${dateStr}T${time}Z`);

//   // Convert to the required timezone (IST +05:30)
//   const options = { timeZone: "Asia/Kolkata", hour12: false, fractionalSecondDigits: 3 };
//   const formattedDate = new Intl.DateTimeFormat("sv-SE", options).format(newDateTime);

//   // Extract formatted parts
//   const [datePart, timePart] = formattedDate.split(" ");
//   return `${datePart}T${timePart}+05:30`;
// };

const combineDateTime = (dateStr, timeStr) => {
  try {
    // Parse the provided date string
    const date = new Date(dateStr);
    if (isNaN(date)) throw new Error("Invalid date format");

    // Parse the provided time string
    const time = new Date(timeStr);
    if (isNaN(time)) throw new Error("Invalid time format");

    // Extract time components (UTC)
    const hours = time.getUTCHours();
    const minutes = time.getUTCMinutes();
    const seconds = time.getUTCSeconds();

    // Combine the date and extracted time in UTC
    const combinedDateTime = new Date(date);
    combinedDateTime.setUTCHours(hours, minutes, seconds, 0);

    // Convert to IST (+05:30)
    const options = {
      timeZone: "Asia/Kolkata",
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };

    // Format the date as "YYYY-MM-DDTHH:mm:ss+05:30"
    const formatter = new Intl.DateTimeFormat("sv-SE", options);
    const formattedDate = formatter.format(combinedDateTime);

    // Extract formatted parts
    const [datePart, timePart] = formattedDate.split(" ");
    return `${datePart}T${timePart}+05:30`;
  } catch (error) {
    console.error("Error in combineDateTime:", error.message);
    return null;
  }
};

// Example Usage
const date = "2025-02-22";
const time = "2025-02-12T22:30:00.000Z";

// Expected output: "2025-02-22T04:00:00+05:30"

// function getFormattedDate(input) {
//   const now = new Date();
//   let date;

//   switch (input.toLowerCase()) {
//     case "today":
//       date = new Date(now);
//       break;
//     case "tomorrow":
//       date = new Date(now);
//       date.setDate(now.getDate() + 1);
//       break;
//     case "day after tomorrow":
//       date = new Date(now);
//       date.setDate(now.getDate() + 2);
//       break;
//     default:
//       throw new Error(
//         'Invalid input. Use "today", "tomorrow", or "day after tomorrow".'
//       );
//   }

//   // Set time to 12 AM (00:00)
//   date.setHours(0, 0, 0, 0);

//   // Return in 'YYYY-MM-DDTHH:mm' format
//   return date.toISOString().slice(0, 16);
// }

function getFormattedDate(input, time = "00:00") {
  const now = new Date();
  let date;

  switch (input.toLowerCase()) {
    case "today":
      date = new Date(now);
      break;
    case "tomorrow":
      date = new Date(now);
      date.setDate(now.getDate() + 1);
      break;
    case "day after tomorrow":
      date = new Date(now);
      date.setDate(now.getDate() + 2);
      break;
    default:
      throw new Error(
        'Invalid input. Use "today", "tomorrow", or "day after tomorrow".'
      );
  }

  // Parse the time (expected format: "HH:mm")
  const [hours, minutes] = time.split(":").map(Number);

  // Set the hours and minutes
  date.setHours(hours, minutes, 0, 0);

  // Return in 'YYYY-MM-DDTHH:mm' format
  return date.toISOString().slice(0, 16);
}

function formatText(text) {
  if (!text) return "";
  return text
    .toLowerCase()
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function convertInK(value) {
  if (value >= 1000) {
    return (value / 1000).toFixed(2) + "k"; // e.g., 102.25k
  }
  return value.toString();
}

export {
  formatShortDateTime,
  formatShortDate,
  customTextColor,
  BgColor,
  formatDate,
  formatTime,
  whichStatus,
  calculateFieldCompletion,
  getCandidateStatus,
  ShortenName,
  splitIntoColumns,
  changeCandidateStatus,
  ShortenName2,
  whichFile,
  convertArrayToString,
  formatArrayString,
  combineDateTime,
  shortDateTime,
  getFormattedDate,
  formatText,
  ShortenName3,
  convertArrayToStringWithCount,
  convertInK,
};
